export default "/images/vendor/flag-icon-css/flags/1x1/ck.svg?d76f3968d6f25ed0bc7d4bb559099de8";